import React, { useState, useEffect, useCallback } from "react";
import { Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import CloudUpload from "@material-ui/icons/CloudUpload";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch } from "react-redux";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InsertDriveFile from "@material-ui/icons/InsertDriveFile";

import DoneIcon from "@material-ui/icons/Done";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";

import _ from "underscore";
import LinearProgress from "@material-ui/core/LinearProgress";

import * as S from "./styles";
import useMutateSignUrl from "../../Hooks/qlp_ddpcr/useMutateSignUrl";
import { formatBytes } from "../../../utils/basic";
import * as awsConstants from "../../../components/constants/fileConstants";
import * as config from "../../../app.config";
import { USER_MESSAGE } from "../../../actions/User";
import { validateDdpcrFileTypes, validateQlpFileTypes } from "../../../utils/basic";
import './FileUpload.css';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#eee",
    textAlign: "center",
    cursor: "pointer",
    color: "#333",
    padding: "10px",
    marginTop: "20px"
  },
  icon: {
    //   marginTop: "6px",
    // paddingLeft: "2px",
    paddingBottom: "14px",
    color: "#888888",
    fontSize: "32px"
  }
}));

const FileUpload = ({ control, name, fileId, fileType, fileClass, props }) => {
  const [isFileDialogActive, setIsFileDialogActive] = useState(false);
  const SLICE_SIZE = 4786 * 1024 * 1024;
  const { actions, filesS3 } = props;

  const dispatch = useDispatch();

  const styles = useStyles();
  const { authState, oktaAuth } = useOktaAuth();
  const onDrop = (acceptedFiles) => {
    console.log("Accepted files:", acceptedFiles);
    // Handle file upload or processing here
  };

  // const onDrop = useCallback((acceptedFiles) => {
  //   // acceptedFiles.map((item) => {
  //   //   console.log({ item });
  //   // });

  // }, []);

  const acceptedFileType = fileClass === awsConstants.ENDPOINTS.qlp ? validateQlpFileTypes(fileType) : fileClass === awsConstants.ENDPOINTS.ddpcr ? validateDdpcrFileTypes(fileType) : "";

  const s3Bucket = acceptedFileType &&
    fileClass === awsConstants.ENDPOINTS.qlp
    ? config.ENDPOINTS.qlpbucket
    : acceptedFileType &&
      fileClass === awsConstants.ENDPOINTS.ddpcr
      ? config.ENDPOINTS.ddpcrbucket
      : "";

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFileType,
    onFileDialogCancel: () => setIsFileDialogActive(false)
  });

  const signUrl = useMutateSignUrl();

  useEffect(() => {
    const fileNames = _.pluck(acceptedFiles, "name");
    if (fileNames?.length > 0) {
      actions.setFiles(fileNames);
      acceptedFiles.forEach(file => {
        handleFileUpload(file);
      });
    }
  }, [acceptedFiles, oktaAuth, authState]);

  const handleFileUpload = f => {
    let iterator = 0;

    var signedUrls = [];
    var file = {
      fileId: crypto.randomUUID(),
      size: f.size,
      name: f.name,
      timeLeft: "",
      percent: 0,
      speed: "",
      startedAt: Math.floor(Date.now() / 1000),
      parts: []
    };
    let fileSize = f.size - 1;

    for (let i = 0; i < fileSize; i += SLICE_SIZE) {
      const start = i;
      const partName =
        fileSize < SLICE_SIZE ? `${f.name}` : `${f.name}.${iterator}.part`;
      const endsAt = SLICE_SIZE + start;
      const blob = f.slice(start, endsAt);
      file.parts.push({ partName: partName, uploaded: 0 });
      //actions.filesS3(fileId, file);
      const toSign = {
        partName,
        blob,
        fileId,
        fileType: fileClass,
        file
      };

      signedUrls.push(signUrl.mutateAsync(toSign));
      iterator++;
    }

    Promise.all(signedUrls).then(signedUrlsData => {
      signedUrlsData.forEach(signedData => {
        return handlePartUpload(
          signedData.partName,
          signedData,
          signedData.blob,
          file,
          fileId
        );
      });
    });
  };

  // const handlePartUpload = (partName, data, blob, fileInfo, fileId) => {
  //   var frmData = new FormData();
  //   frmData.set("acl", data.upload_fields.fields.acl);
  //   frmData.set("key", data.upload_fields.fields.key);
  //   frmData.set("policy", data.upload_fields.fields.policy);
  //   frmData.set(
  //     "x-amz-algorithm",
  //     data.upload_fields.fields["x-amz-algorithm"]
  //   );
  //   frmData.set(
  //     "x-amz-credential",
  //     data.upload_fields.fields["x-amz-credential"]
  //   );
  //   frmData.set("x-amz-date", data.upload_fields.fields["x-amz-date"]);
  //   frmData.set(
  //     "x-amz-security-token",
  //     data.upload_fields.fields["x-amz-security-token"]
  //   );
  //   frmData.set(
  //     "x-amz-signature",
  //     data.upload_fields.fields["x-amz-signature"]
  //   );
  //   frmData.set("file", blob, partName);

  //   axios({
  //     method: "post",
  //     url: awsConstants.ENDPOINTS.endPointUrl + `/` + s3Bucket,
  //     data: frmData,
  //     headers: {
  //       "Content-Type": "multipart/form-data"
  //     },
  //     onUploadProgress: _.debounce(progressEvent => {
  //       let files = [];
  //       files.push(fileInfo);
  //       let mainFile = partName.split(".");
  //       mainFile =
  //         fileInfo.size < SLICE_SIZE
  //           ? mainFile.join(".")
  //           : mainFile.slice(0, -2).join(".");
  //       let thisFileIndex = _.findIndex(files, { name: mainFile });
  //       let thisPartIndex = _.findIndex(files[thisFileIndex].parts, {
  //         partName: partName
  //       });

  //       actions.filesS3SignedUploaded(
  //         fileId,
  //         files,
  //         thisFileIndex,
  //         thisPartIndex,
  //         progressEvent
  //       );

  //       dispatch({
  //         type: USER_MESSAGE,
  //         msgType: "success",
  //         text: `${partName} File Uploaded Successfully`,
  //         key: Math.floor(Date.now() / 1000)
  //       });
  //     }, 200)
  //   }).catch(err => {
  //     console.log({ err });
  //     dispatch({
  //       type: USER_MESSAGE,
  //       msgType: "error",
  //       text: "Files Failed to Upload",
  //       key: Math.floor(Date.now() / 1000)
  //     });
  //   });
  // };

  const handlePartUpload = async (partName, data, blob, fileInfo, fileId) => {
    try {
      const frmData = new FormData();
      frmData.set("acl", data.upload_fields.fields.acl);
      frmData.set("key", data.upload_fields.fields.key);
      frmData.set("policy", data.upload_fields.fields.policy);
      frmData.set("x-amz-algorithm", data.upload_fields.fields["x-amz-algorithm"]);
      frmData.set("x-amz-credential", data.upload_fields.fields["x-amz-credential"]);
      frmData.set("x-amz-date", data.upload_fields.fields["x-amz-date"]);
      frmData.set("x-amz-security-token", data.upload_fields.fields["x-amz-security-token"]);
      frmData.set("x-amz-signature", data.upload_fields.fields["x-amz-signature"]);
      frmData.set("file", blob, partName);

      const s3Url = `${config.ENDPOINTS.uploadUrl}/${s3Bucket}`;
      console.log({ s3Url });

      // Make the API call and wait for the response
      const response = await axios.post(s3Url, frmData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: _.debounce((progressEvent) => {
          let files = [];
          files.push(fileInfo);
          let mainFile = partName.split(".");
          mainFile =
            fileInfo.size < SLICE_SIZE
              ? mainFile.join(".")
              : mainFile.slice(0, -2).join(".");
          let thisFileIndex = _.findIndex(files, { name: mainFile });
          let thisPartIndex = _.findIndex(files[thisFileIndex].parts, {
            partName: partName,
          });

          // Update the progress in your state or UI
          actions.filesS3SignedUploaded(
            fileId,
            files,
            thisFileIndex,
            thisPartIndex,
            progressEvent
          );
        }, 200),
      });

      // Check the response status
      if (response.status === 204 || response.status === 200) {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: `${partName} File Uploaded Successfully`,
          key: Math.floor(Date.now() / 1000),
        });
      } else {
        throw new Error(`Upload failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Upload error:", error);
      dispatch({
        type: USER_MESSAGE,
        msgType: "error",
        text: "File Failed to Upload",
        key: Math.floor(Date.now() / 1000),
      });
    }
  };

  const filesHtml =
    filesS3?.length > 0 &&
    filesS3.map(f => (
      <div className="fileStatus" key={f.name}>
        <div className="grid-x grid-margin-x align-middle">
          <div className="cell small-5">{f.name}</div>
          <div className="cell small-2">{formatBytes(f.size)}</div>
          <div>{`${f.percent} %`}</div>
          <div className="cell auto">
            <Tooltip
              title={
                f.speed
                  ? `Uploading file at ${f.speed} Kbps `
                  : "Calculating speed."
              }
              placement="top"
            >
              <LinearProgress variant="determinate" value={f.percent} />
            </Tooltip>
          </div>
        </div>
      </div>
    ));

  const uploadComplete =
    (!_.isEmpty(filesS3) &&
      _.every(filesS3, function (file) {
        return file.percent === 100;
      })) ||
    false;

  if (uploadComplete) {
    actions.fileUploadCompletedStatus(fileId, true);
  }

  // const callOutAlert = state.error && (
  //     <div className="callout alert">
  //         <div className="grid-x grid-margin-x align-middle">
  //             <div className="cell small-1">
  //                 <WarningIcon />
  //             </div>
  //             <div className="cell auto">{state.error}</div>
  //         </div>
  //     </div>
  // )

  const callOutSuccess = () => {
    if (!uploadComplete) return null;

    return (
      <div className="callout success">
        <div className="grid-x grid-margin-x align-middle">
          <div className="cell small-1">
            <DoneIcon />
          </div>
          <div className="cell auto">
            <p>{_.size(filesS3)} files uploaded successfully! </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={[]}
        render={({ onChange, onBlur, value }) => (
          <>
            <div {...getRootProps({
              onFocus: () => setIsFileDialogActive(true),
              onBlur: () => setIsFileDialogActive(false)
            })}
              style={getStyle(isDragActive, isFileDialogActive)}
            //className={`dropzone ${isDragActive || isFileDialogActive ? 'active' : ''}`}
            >
              <input {...getInputProps()} />
              <CloudUpload className={styles.icon} />
              {isDragActive ? (
                <p>Drop the files here ...</p>
              ) : (
                <p>Drag & drop some files here, or click to select files</p>
              )}
              {/* <p>Drag 'n' drop files here, or click to select files.</p> */}

              <em>(Only {acceptedFileType.join(',')} files will be accepted)</em>
            </div>
            <aside>
              <h6>Accepted Files</h6>
              <List>
                {acceptedFiles.length > 0 &&
                  acceptedFiles.map(f => (
                    <ListItem key={crypto.randomUUID()}>
                      <ListItemIcon>
                        <InsertDriveFile />
                      </ListItemIcon>
                      <ListItemText primary={f.name} secondary={f.size} />
                    </ListItem>
                  ))}
              </List>
            </aside>
          </>
        )}
      />
      {!_.isEmpty(filesS3) && (
        <div className="callout secondary">
          <h4>Files</h4>
          <ul>{filesHtml}</ul>
        </div>
      )}
      {callOutSuccess}
    </>
  );
};

const getStyle = (isDragActive, isFileDialogActive) => ({
  border: "2px dashed",
  //borderColor: isDragActive || isFileDialogActive ? "red" : "gray",
  borderColor: "gray",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer"
});

export default FileUpload;
